import axiosInstance from "./AxiosConfig";
import {REST_API_BASE_URL_REMOTE} from '../services/PathEnvironment'

const REST_API_BASE_URL = REST_API_BASE_URL_REMOTE + 'api/usertalent';

export const getUserTalentByUserId = (userId) => axiosInstance.get(REST_API_BASE_URL + '/user/' + userId);

export const upsertUserTalent = (userTalent) => axiosInstance.put(REST_API_BASE_URL, userTalent);

export const getUserTalentsByKeyword = (keyword, page, size, sortField, sortDirection = 'asc') => {
  return axiosInstance.get(REST_API_BASE_URL, { params: { searchText: keyword || '', page, size, sort: `${sortField},${sortDirection}` } });
};
